export default __webpack_public_path__ + "static/yellow-fever-1980d957ff26cd04ace1393026dd9442.png";